import loadable from '@loadable/component'
import React from 'react'
import { MyHomeSkeleton } from './my-home.skeleton'
import { isFeatureEnabled } from 'common/feature-togglings/features'
import { Status404Error } from 'project-watchtower'
import { createRegisterableComponent } from 'common/routing/page-definition'

const LazyMyHome = loadable(() => import('./my-home'), {
    fallback: <MyHomeSkeleton />,
})

export const MyHomeRegistration = createRegisterableComponent('my-home', (_, services) => {
    if (!isFeatureEnabled(services.store.getState().toggles, 'my-home')) {
        throw new Status404Error()
    }

    return <LazyMyHome services={services} />
})
